import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@custom-components';
import { Wrapper } from './FullScreenSpinner.styles';

export function FullScreenSpinner({ disabled }) {
  if (disabled) return null;

  return (
    <Wrapper>
      <Spinner thickness={4} size={40} />
    </Wrapper>
  );
}
FullScreenSpinner.propTypes = {
  disabled: PropTypes.bool
};
FullScreenSpinner.defaultProps = {
  disabled: false
};

export default FullScreenSpinner;
